module.exports = __webpack_public_path__ + "img/home-imagen3.8fd36120.png";